// extracted by mini-css-extract-plugin
export default {"outerFlex":"RulesContent_outerFlex__8ZvJp","heading":"RulesContent_heading__4OY1E","innerFlex":"RulesContent_innerFlex__X+KcE"};